/** Only an explicit server pending state is an approval-waiting account. */
export function identitySessionFailure(state: unknown): string | null {
  if (state === 'active' || state === 'pending' || state === 'registration-required') return null;
  if (state === 'suspended') return 'ACCOUNT_SUSPENDED';
  if (state === 'rejected') return 'ACCOUNT_REJECTED';
  if (state === 'departed') return 'ACCOUNT_DEPARTED';
  if (state === 'authority-unavailable') return 'ACCOUNT_AUTHORITY_UNAVAILABLE';
  if (state === 'unregistered') return 'ACCOUNT_REGISTRATION_INCOMPLETE';
  return 'SESSION_STATE_INVALID';
}
